import { orderItemsActions } from '../../../../redux/actions/medication/drugs/orders';

// Initial state structure
const initialState = {
  orderItems: [], // List of order items
  loading: false, // Indicates if data is being fetched or posted
  error: null // Holds error details, if any
};

/**
 * Reducer to manage order items.
 * Handles actions related to fetching, adding, and deleting order items.
 *
 * @param {Object} state - The current state of order items.
 * @param {Object} action - The dispatched action.
 * @returns {Object} - Updated state based on the action.
 */
const orderItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle loading state for all actions
    case orderItemsActions.FETCH_ORDER_ITEMS.REQUEST:
    case orderItemsActions.POST_ORDER_ITEM.REQUEST:
    case orderItemsActions.DELETE_ORDER_ITEM.REQUEST:
      return {
        ...state,
        loading: true, // Set loading to true while action is in progress
        error: null // Clear previous error
      };

      // Handle fetch success: Updates order items with fetched data
    case orderItemsActions.FETCH_ORDER_ITEMS.SUCCESS:
      return {
        ...state,
        loading: false, // Set loading to false after success
        orderItems: action.payload // Update orderItems with fetched data
      };

      // Handle post success: Adds a new order item
    case orderItemsActions.POST_ORDER_ITEM.SUCCESS:
      return {
        ...state,
        loading: false,
        orderItems: [...state.orderItems, action.payload] // Add new item to the list
      };

      // Handle delete success: Removes the order item by id
    case orderItemsActions.DELETE_ORDER_ITEM.SUCCESS:
      return {
        ...state,
        loading: false,
        orderItems: state.orderItems.filter(item => item.id !== action.payload) // Filter out the deleted item
      };

      // Handle failure for all actions: Updates the state with error message
    case orderItemsActions.FETCH_ORDER_ITEMS.FAILURE:
    case orderItemsActions.POST_ORDER_ITEM.FAILURE:
    case orderItemsActions.DELETE_ORDER_ITEM.FAILURE:
      return {
        ...state,
        loading: false, // Set loading to false after failure
        error: action.error // Capture error details
      };

      // Default case: Return the current state if no matching action is found
    default:
      return state;
  }
};

export default orderItemsReducer;
